import '../../../../../models/cart/cart-state.js';
import '../../../../../models/checkout/checkout-step-error-type.js';
import '../../../../../models/checkout-settings.js';
import { ShippingMethod } from '../../../../../models/step-shipping/shipping-methods.js';
import '../../../../../models/shared.js';

var ApplePayShippingTypes;
(function(ApplePayShippingTypes) {
    ApplePayShippingTypes["SHIPPING"] = 'shipping';
    ApplePayShippingTypes["DELIVERY"] = 'delivery';
    ApplePayShippingTypes["STORE_PICKUP_UP"] = 'storePickup';
    ApplePayShippingTypes["SERVICE_PICKUP"] = 'servicePickup';
})(ApplePayShippingTypes || (ApplePayShippingTypes = {}));
const mapper = {
    [ShippingMethod.Delivery]: ApplePayShippingTypes.DELIVERY,
    [ShippingMethod.DeliveryExpress]: ApplePayShippingTypes.DELIVERY,
    [ShippingMethod.Pickup]: ApplePayShippingTypes.STORE_PICKUP_UP,
    [ShippingMethod.PickupPoint]: ApplePayShippingTypes.SERVICE_PICKUP,
    [ShippingMethod.NearestPickup]: ApplePayShippingTypes.SERVICE_PICKUP
};
const mapGVShippingMethodToApplePayShippingType = (shippingMethod)=>mapper[shippingMethod]
;

export { ApplePayShippingTypes, mapGVShippingMethodToApplePayShippingType };
//# sourceMappingURL=apple-pay-shipping-types.js.map
